import { HSSalesPackage } from "../../../models/server/homeSales";
import { retailerFetch } from "./retailerFetch";
import {
    API_URL_RETAILER_FWA_BANKID_STATUS,
    API_URL_RETAILER_FWA_SELECT_PACKAGE,
    API_URL_RETAILER_FWA_SEND_SIGNING_SMS,
    API_URL_RETAILER_FWA_SUBMIT,
} from "./api";

export const saveFwaPackageToOrder = async (pkg: HSSalesPackage): Promise<void> => {
    const res = await retailerFetch(API_URL_RETAILER_FWA_SELECT_PACKAGE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ packageId: pkg.id }),
    });
    if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error((json as { error?: string }).error ?? `Feil ved lagring av pakke (${res.status})`);
    }
};

export const sendFwaSigningSms = async (): Promise<void> => {
    const res = await retailerFetch(API_URL_RETAILER_FWA_SEND_SIGNING_SMS, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
    });
    if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error((json as { error?: string }).error ?? `Feil ved sending av SMS (${res.status})`);
    }
};

export const checkFwaBankIdStatus = async (): Promise<{ completed: boolean }> => {
    const res = await retailerFetch(API_URL_RETAILER_FWA_BANKID_STATUS);
    if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error((json as { error?: string }).error ?? `Feil ved statussjekk (${res.status})`);
    }
    return res.json() as Promise<{ completed: boolean }>;
};

export const submitFwaOrder = async (): Promise<{ ticketId: string; orderRef: string }> => {
    const res = await retailerFetch(API_URL_RETAILER_FWA_SUBMIT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw new Error((json as { error?: string }).error ?? `Feil ved innsending av ordre (${res.status})`);
    }
    return json as { ticketId: string; orderRef: string };
};
